import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from './index'
import type { IClientUID } from '../clients'

export async function getClientTestEnvironment(clientId: IClientUID): Promise<ApiResponse<boolean>> {
    const response = await fetch(`${HOST_URL}test-environment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<boolean>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function updateClientTestEnvironment(clientId: IClientUID, state: boolean): Promise<ApiResponse<void>> {
    const response = await fetch(`${HOST_URL}test-environment`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, state }),
    })
    const result = (await response.json()) as ApiResponse<void>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
